var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderNotFound = function SvgFolderNotFound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.8857 106.531L23.7814 100.353C23.517 99.5393 23.9471 98.6641 24.7602 98.3617L39.2063 92.9157L46.8306 91.8669C47.6051 91.7627 48.3452 92.2155 48.5923 92.9446L50.2757 97.9768C50.5445 98.7133 50.2238 99.5321 49.5221 99.9012L42.7591 103.529L27.853 107.599C27.0115 107.823 26.1406 107.35 25.8857 106.531V106.531Z",
    fill: "#C1C7CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.077 107.496L101.805 98.0395C101.591 97.1678 100.714 96.6299 99.8372 96.8329L60.3373 106.29C59.9159 106.39 59.5516 106.653 59.3246 107.021C59.0977 107.389 59.0267 107.832 59.1272 108.252L57.5531 108.634C57.1303 108.732 56.7643 108.995 56.537 109.363C56.3096 109.732 56.2397 110.176 56.343 110.596L58.2418 118.444C58.3422 118.865 58.6059 119.228 58.9749 119.454C59.3439 119.68 59.788 119.751 60.2094 119.651L61.7933 119.268L65.5908 135.043C65.6888 135.465 65.9521 135.83 66.3218 136.056C66.6915 136.283 67.1369 136.353 67.5584 136.25L107.117 126.793C107.991 126.58 108.528 125.703 108.318 124.831L106.803 118.513L108.377 118.14C109.251 117.927 109.79 117.052 109.587 116.178L107.688 108.33C107.588 107.91 107.324 107.548 106.954 107.323C106.585 107.098 106.141 107.03 105.72 107.133L104.077 107.496Z",
    fill: "#C1C7CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.2472 73.3711C46.4407 72.9858 46.473 72.5392 46.3369 72.13C46.2009 71.7208 45.9077 71.3829 45.5223 71.1911L33.9438 65.3582C33.5595 65.1642 33.1139 65.1318 32.7057 65.2682C32.2975 65.4046 31.9605 65.6985 31.7691 66.0848L31.4067 66.8115H23.3448C22.4522 66.8115 21.7285 67.5369 21.7285 68.4317V81.4723C21.7259 81.9037 21.8951 82.3184 22.1985 82.6244C22.5019 82.9303 22.9145 83.1024 23.3448 83.1024H32.9838L38.2441 85.7537C38.6379 85.9511 39.0946 85.98 39.51 85.8337C39.9254 85.6875 40.2639 85.3788 40.4481 84.9779L46.2472 73.3711Z",
    fill: "#C1C7CD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7158,
    y: 66.1729,
    width: 14.8148,
    height: 14.8148,
    rx: 2.64,
    fill: "#DBE9F9",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5551 78.2096C27.2394 77.5812 26.6823 76.0052 27.3106 74.6895L31.42 66.0857C32.0484 64.77 33.6244 64.2129 34.94 64.8413L43.5439 68.9506C44.8595 69.579 45.4167 71.155 44.7883 72.4707L40.6789 81.0745C40.0506 82.3902 38.4746 82.9473 37.1589 82.3189L28.5551 78.2096Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.26 104.634L121.847 111.266C121.096 113.338 121.52 115.649 122.96 117.328C124.399 119.008 126.636 119.8 128.827 119.407C131.017 119.014 132.83 117.495 133.581 115.423L135.994 108.801C137.026 105.635 135.333 102.23 132.166 101.105C128.999 99.9807 125.501 101.542 124.26 104.634V104.634Z",
    fill: "#C1C7CD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M98.7655 93.8272H61.2347C58.5073 93.8272 56.2964 91.5548 56.2964 88.7516V77.0371H103.704V88.7922C103.682 91.5795 101.477 93.8273 98.7655 93.8272Z",
    fill: "#C1C7CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.457 53.5678C123.457 52.1962 111.791 51.0371 95.3748 50.5831V50.3706H64.6247V50.5831C48.2082 51.0371 36.543 52.1962 36.543 53.5678C36.543 54.9394 47.8511 56.0695 63.8907 56.5332L63.6328 58.6679C63.4164 60.571 64.0389 62.4742 65.3456 63.9051C66.6523 65.3359 68.5208 66.1601 70.4871 66.1731H89.4926C91.4589 66.1601 93.3273 65.3359 94.6341 63.9051C95.9408 62.4742 96.5632 60.571 96.3469 58.6679L96.089 56.5332C112.129 56.0695 123.457 54.9104 123.457 53.5678Z",
    fill: "#C1C7CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4682 88.8888H60.5223C58.7339 88.8888 57.2842 87.4208 57.2842 85.6099V70.7752C57.2842 69.8698 58.0091 69.1357 58.9032 69.1357H101.097C101.991 69.1357 102.716 69.8698 102.716 70.7752V85.5702C102.724 86.4476 102.385 87.2918 101.775 87.915C101.165 88.5383 100.335 88.8889 99.4682 88.8888V88.8888Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4682 88.8888H60.5223C58.7339 88.8888 57.2842 87.4208 57.2842 85.6099V70.7752C57.2842 69.8698 58.0091 69.1357 58.9032 69.1357H101.097C101.991 69.1357 102.716 69.8698 102.716 70.7752V85.5702C102.724 86.4476 102.385 87.2918 101.775 87.915C101.165 88.5383 100.335 88.8889 99.4682 88.8888V88.8888Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2222 83.9507H65.1851",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2222 79.0122H65.1851",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2222 74.0742H65.1851",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1479 79.0122H71.1109",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1479 74.0742H71.1109",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0615 79.0122H78.0245",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0615 74.0742H78.0245",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9751 79.0122H84.9381",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9751 74.0742H84.9381",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9014 79.0122H90.8643",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9014 74.0742H90.8643",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8149 83.9507H97.7779",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8149 79.0122H97.7779",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8149 74.0742H97.7779",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1479 83.9507H90.864",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M140.383 21.7285H19.6169C17.6418 21.7281 15.8029 22.6959 14.7389 24.2956C13.6749 25.8954 13.5328 27.9063 14.3619 29.6297H145.638C146.467 27.9063 146.325 25.8954 145.261 24.2956C144.197 22.6959 142.358 21.7281 140.383 21.7285V21.7285Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.383 21.7285H19.6169C17.6418 21.7281 15.8029 22.6959 14.7389 24.2956C13.6749 25.8954 13.5328 27.9063 14.3619 29.6297H145.638C146.467 27.9063 146.325 25.8954 145.261 24.2956C144.197 22.6959 142.358 21.7281 140.383 21.7285V21.7285Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6663 34.5679H72.3465C69.0803 34.5698 66.3312 37.0376 65.9464 40.3132L64.2416 54.9618C64.0274 56.8066 64.6045 58.6559 65.8275 60.0433C67.0504 61.4306 68.8025 62.2236 70.6417 62.2222H88.3711C90.2103 62.2236 91.9624 61.4306 93.1853 60.0433C94.4083 58.6559 94.9854 56.8066 94.7712 54.9618L93.0664 40.3132C92.6816 37.0376 89.9325 34.5698 86.6663 34.5679V34.5679Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6663 34.5679H72.3465C69.0803 34.5698 66.3312 37.0376 65.9464 40.3132L64.2416 54.9618C64.0274 56.8066 64.6045 58.6559 65.8275 60.0433C67.0504 61.4306 68.8025 62.2236 70.6417 62.2222H88.3711C90.2103 62.2236 91.9624 61.4306 93.1853 60.0433C94.4083 58.6559 94.9854 56.8066 94.7712 54.9618L93.0664 40.3132C92.6816 37.0376 89.9325 34.5698 86.6663 34.5679V34.5679Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M142.91 24.6914H17.0845C15.9108 24.6971 14.8299 25.3352 14.2518 26.3636C13.6736 27.392 13.6867 28.6534 14.286 29.6695L24.6198 46.9933C25.515 48.4739 27.1108 49.379 28.8324 49.3828H131.181C132.903 49.379 134.499 48.4739 135.394 46.9933L145.708 29.6795C146.313 28.6628 146.328 27.3977 145.75 26.3661C145.171 25.3344 144.086 24.695 142.91 24.6914V24.6914Z",
    fill: "#DBE9F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8133 49.3828H55.4648L80 24.6914H17.0846C15.9109 24.6971 14.83 25.3352 14.2518 26.3636C13.6736 27.392 13.6867 28.6534 14.286 29.6695L24.6202 46.9933C25.5118 48.4678 27.0986 49.3721 28.8133 49.3828V49.3828Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.91 24.6914H17.0845C15.9108 24.6971 14.8299 25.3352 14.2518 26.3636C13.6736 27.392 13.6867 28.6534 14.286 29.6695L24.6198 46.9933C25.515 48.4739 27.1108 49.379 28.8324 49.3828H131.181C132.903 49.379 134.499 48.4739 135.394 46.9933L145.708 29.6795C146.313 28.6628 146.328 27.3977 145.75 26.3661C145.171 25.3344 144.086 24.695 142.91 24.6914V24.6914Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7158 44.4443L24.2454 46.9931C25.1387 48.4737 26.7311 49.3789 28.4491 49.3826H130.583C132.301 49.3789 133.893 48.4737 134.786 46.9931L136.296 44.4443L22.7158 44.4443Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7158 44.4443L24.2454 46.9931C25.1387 48.4737 26.7311 49.3789 28.4491 49.3826H130.583C132.301 49.3789 133.893 48.4737 134.786 46.9931L136.296 44.4443L22.7158 44.4443Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.486 100.097C129.04 99.5751 127.446 99.6493 126.056 100.303C124.666 100.957 123.595 102.137 123.079 103.581L120.837 109.791C119.754 112.795 121.318 116.107 124.33 117.188C127.343 118.269 130.663 116.709 131.747 113.704L133.979 107.484C134.499 106.043 134.423 104.454 133.768 103.068C133.113 101.682 131.932 100.613 130.486 100.097V100.097Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.486 100.097C129.04 99.5751 127.446 99.6493 126.056 100.303C124.666 100.957 123.595 102.137 123.079 103.581L120.837 109.791C119.754 112.795 121.318 116.107 124.33 117.188C127.343 118.269 130.663 116.709 131.747 113.704L133.979 107.484C134.499 106.043 134.423 104.454 133.768 103.068C133.113 101.682 131.932 100.613 130.486 100.097V100.097Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M128.76 103.722C128.337 103.725 127.961 104 127.822 104.411C127.666 104.924 127.928 105.474 128.419 105.662C128.531 105.685 128.647 105.685 128.76 105.662C129.185 105.661 129.565 105.386 129.709 104.974C129.864 104.456 129.596 103.906 129.1 103.722C128.988 103.697 128.872 103.697 128.76 103.722V103.722Z",
    fill: "#C1C7CD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.63 140.263L107.536 142.539C107.87 143.378 107.474 144.333 106.649 144.676L87.6361 152.482C87.4372 152.563 87.2146 152.561 87.0174 152.476C86.8201 152.39 86.6643 152.229 86.5842 152.027L86.5355 151.898L85.3959 152.353C85.2306 153.512 84.4694 154.492 83.3991 154.926C82.1913 155.401 79.727 154.52 78.5289 153.996C78.3243 153.913 78.1622 153.749 78.0811 153.541C78 153.333 78.0069 153.1 78.1003 152.898C78.675 151.661 79.8828 149.306 81.0906 148.831C82.1554 148.407 83.3618 148.592 84.2562 149.316L85.3764 148.861L85.1231 148.238C85.043 148.036 85.0452 147.809 85.1293 147.609C85.2133 147.409 85.3723 147.25 85.5712 147.169L104.584 139.363C105.394 139.056 106.297 139.453 106.63 140.263V140.263Z",
    fill: "#C1C7CD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6686 108.981C58.3287 107.563 59.2026 106.139 60.6205 105.799L74.6949 102.425C76.1127 102.085 77.5377 102.959 77.8775 104.377L83.5536 128.056C83.8935 129.473 83.0196 130.898 81.6017 131.238L67.5273 134.612C66.1095 134.952 64.6845 134.078 64.3447 132.66L58.6686 108.981Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3844 103.056C81.0446 101.638 81.9184 100.213 83.3363 99.8729L97.4107 96.4991C98.8286 96.1592 100.253 97.0331 100.593 98.451L106.269 122.13C106.609 123.548 105.735 124.973 104.318 125.312L90.2432 128.686C88.8253 129.026 87.4004 128.152 87.0605 126.734L81.3844 103.056Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0493 105.679L81.9752 103.704",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0371 108.642L82.963 106.667",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0249 111.605L83.9508 109.629",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0122 114.568L84.9381 112.593",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M80 118.518L85.9259 116.543",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121.482L85.9259 119.506",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9878 124.445L86.9137 122.469",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9751 127.407L87.901 125.432",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6292 112.767L56.9711 113.58L56.3355 110.179C56.2489 109.726 56.3075 109.248 56.4982 108.851C56.689 108.454 56.9961 108.171 57.3509 108.066L58.6717 107.654L59.6292 112.767Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8647 117.738L59.4158 118.104C59.0302 118.203 58.6228 118.136 58.2846 117.919C57.9465 117.702 57.7056 117.353 57.616 116.949L56.9141 113.934L59.8118 113.21L60.8647 117.738Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M106.049 110.882L103.601 111.605L102.716 107.077L103.944 106.711C104.271 106.612 104.616 106.679 104.902 106.896C105.189 107.113 105.393 107.463 105.469 107.866L106.049 110.882Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M107.605 114.384C107.711 114.836 107.644 115.315 107.419 115.714C107.194 116.112 106.83 116.395 106.409 116.501L104.831 116.913L103.704 111.802L106.85 110.987L107.605 114.384Z",
    fill: "white",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1145 108.676C69.2161 109.072 68.9439 109.468 68.5003 109.569L63.6369 110.596C63.1894 110.692 62.7393 110.448 62.63 110.052L62.2474 108.614C62.193 108.423 62.2274 108.221 62.343 108.053C62.4585 107.885 62.6454 107.765 62.8616 107.721L67.725 106.685C67.9383 106.643 68.1616 106.674 68.3492 106.774C68.5361 106.876 68.6699 107.04 68.7218 107.229L69.1145 108.676Z",
    fill: "#E6E8EB",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8581 126.9C66.5182 125.482 67.3921 124.057 68.8099 123.718L74.4813 122.358C75.8992 122.018 77.3241 122.892 77.664 124.31L78.0448 125.899C78.3847 127.316 77.5108 128.741 76.0929 129.081L70.4215 130.441C69.0037 130.781 67.5787 129.907 67.2389 128.489L66.8581 126.9Z",
    fill: "#E6E8EB",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0718 114.198L71.973 112.223",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8154 117.283L75.6796 114.32",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1851 120.863L76.0493 117.9",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9517 105.014C92.4025 106.868 94.2699 108.006 96.1236 107.556C97.9773 107.106 99.116 105.239 98.6675 103.385C98.219 101.531 96.353 100.39 94.4988 100.838C93.6053 101.051 92.8338 101.611 92.3555 102.395C91.8773 103.18 91.7319 104.122 91.9517 105.014V105.014Z",
    fill: "#E6E8EB",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9644 121.804C91.4152 123.658 93.2826 124.796 95.1363 124.346C96.99 123.896 98.1287 122.029 97.6802 120.175C97.2317 118.321 95.3657 117.181 93.5115 117.628C92.618 117.841 91.8465 118.401 91.3682 119.186C90.89 119.97 90.7446 120.912 90.9644 121.804V121.804Z",
    fill: "#E6E8EB",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4157 104.691L89.8765 105.06L92.8394 117.531",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8516 113.353L94.8145 112.593",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7315 111.825C99.8317 112.26 99.5755 112.697 99.1584 112.804L96.1332 113.557C95.7157 113.662 95.2957 113.395 95.1937 112.96L94.8367 111.384C94.788 111.174 94.8218 110.952 94.9307 110.768C95.0393 110.587 95.2111 110.457 95.4098 110.406L98.435 109.652C98.8525 109.548 99.2725 109.815 99.3745 110.249L99.7315 111.825Z",
    fill: "#E6E8EB",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4692 102.134L39.7026 92.8394L25.7415 97.7726C24.9514 98.077 24.5233 98.932 24.7535 99.7459L26.1763 104.502C26.421 105.349 27.2973 105.848 28.1524 105.626L42.4692 102.134Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7022 96.5924L47.6228 93.0146C47.3944 92.2747 46.6693 91.7924 45.8839 91.858L38.8882 92.4951L41.6865 101.729L47.8927 98.4449C48.5757 98.0933 48.9136 97.32 48.7022 96.5924V96.5924Z",
    fill: "#C1C7CD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4692 102.134L39.7026 92.8394L25.7415 97.7726C24.9514 98.077 24.5233 98.932 24.7535 99.7459L26.1763 104.502C26.421 105.349 27.2973 105.848 28.1524 105.626L42.4692 102.134Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3203 96.5924L48.241 93.0146C48.0125 92.2747 47.2874 91.7924 46.5021 91.858L39.5063 92.4951L42.3046 101.729L48.5108 98.4449C49.1938 98.0933 49.5317 97.32 49.3203 96.5924V96.5924Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2598 101.111L35.1857 99.1353",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7243 148.812C84.2296 147.541 84.8588 146.11 86.1296 145.615L102.696 139.166C103.967 138.671 105.398 139.3 105.893 140.571C106.388 141.842 105.759 143.273 104.488 143.768L87.921 150.217C86.6502 150.712 85.219 150.082 84.7243 148.812Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.79 141.234L98.7653 146.173",
    stroke: "#C1C7CD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M102.716 138.682C102.416 137.756 101.821 137.011 101.062 136.612C100.303 136.212 99.4427 136.191 98.6708 136.554L92.8394 139.259",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4802 151.988C83.6669 151.488 84.2549 150.04 83.7935 148.754C83.3322 147.468 81.9962 146.831 80.8094 147.331C79.6214 147.834 78.0249 151.173 78.0249 151.173C78.0249 151.173 81.2921 152.481 82.4802 151.988V151.988Z",
    fill: "#E6E8EB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4802 151.988C83.6669 151.488 84.2549 150.04 83.7935 148.754C83.3322 147.468 81.9962 146.831 80.8094 147.331C79.6214 147.834 78.0249 151.173 78.0249 151.173C78.0249 151.173 81.2921 152.481 82.4802 151.988V151.988Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7243 148.812C84.2296 147.541 84.8588 146.11 86.1296 145.615L102.696 139.166C103.967 138.671 105.398 139.3 105.893 140.571C106.388 141.842 105.759 143.273 104.488 143.768L87.921 150.217C86.6502 150.712 85.219 150.082 84.7243 148.812Z",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118.429 87.8856C117.161 87.3013 116.606 85.7997 117.191 84.5317L126.235 64.9045C126.819 63.6365 128.321 63.0822 129.589 63.6665L139.349 68.1639C140.617 68.7482 141.171 70.2498 140.587 71.5179L131.543 91.145C130.959 92.413 129.457 92.9673 128.189 92.383L118.429 87.8856Z",
    fill: "#C1C7CD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M125.368 63.8534C125.734 63.0493 126.683 62.6945 127.487 63.061L137.157 67.468C137.962 67.8344 138.316 68.7833 137.95 69.5874L129.447 88.245C129.081 89.0491 128.132 89.4039 127.328 89.0374L117.657 84.6304C116.853 84.264 116.499 83.3151 116.865 82.511L125.368 63.8534Z",
    fill: "#C1C7CD",
    stroke: "#7C7D7F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M124.567 66.1729L136.048 71.8471L130 85.9259L118.519 80.2517L124.567 66.1729Z",
    fill: "#DBE9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M119.506 78.0247L136.296 71.6336L124.802 66.1729L119.506 78.0247Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M124.17 66.1006L136.525 71.6604",
    stroke: "#7C7D7F",
    strokeWidth: 1.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.992 80.3091L130.347 85.8689",
    stroke: "#7C7D7F",
    strokeWidth: 1.6
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder_not_found.59f1f2ae1df223c7916868579f08f550.svg";